// extracted by mini-css-extract-plugin
module.exports = {"optionRequestNewImage":"RejectionDetailDialog_optionRequestNewImage__gghcn","alert":"RejectionDetailDialog_alert__26ZVq"};